// extracted by mini-css-extract-plugin
export default {"marketplaceMenuSA":"_1f3gshu","marketplaceMenuSa":"_1f3gshu","marketplaceMenu":"_1k07eno","search-menu":"_egne32","searchMenu":"_egne32"};